import type { ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { TruncatedTextWithTooltip } from "app/pages/sales-intelligence/common-components/TruncatedText";

import { StyledTopCompaniesEmptyState, StyledTopCompanyEmptyIcon } from "./styles";

interface IProps {
    isError?: boolean;
}

const TopCompaniesEmptyState = ({ isError }: IProps): ReactElement => {
    return (
        <StyledTopCompaniesEmptyState
            gap="16px"
            justifyContent="center"
            alignItems="center"
            alignSelf="stretch"
            data-automation="top-companies.empty-state"
        >
            <StyledTopCompanyEmptyIcon
                iconName="no-data-lab-2"
                size="xxl"
            />

            <Stack alignItems="center">
                <TruncatedTextWithTooltip
                    fontVariant="subtitle1"
                    color={colorsPalettes.carbon[500]}
                >
                    {translate(`si.top-companies.${isError ? "error" : "empty"}-state.title`)}
                </TruncatedTextWithTooltip>
                <TruncatedTextWithTooltip
                    fontVariant="caption"
                    color={colorsPalettes.carbon[300]}
                >
                    {translate(`si.top-companies.${isError ? "error" : "empty"}-state.subtitle`)}
                </TruncatedTextWithTooltip>
            </Stack>
        </StyledTopCompaniesEmptyState>
    );
};

export default TopCompaniesEmptyState;
